// Severity classifier for risk-alert layered signals (Q3 — DESIGN-DECISIONS-2026-05-01).
//
// TASK-35: NotificationModel now carries a `severity` column (critical | red |
// amber | info). Stored notifications should prefer the persisted column;
// `severityForEventType` remains for the WS pubsub path and as the fallback
// for legacy rows written before TASK-35 (no severity field).

export type AlertSeverity = "critical" | "red" | "amber" | "info";

export function severityForEventType(eventType: string): AlertSeverity {
  switch (eventType) {
    case "risk_score.critical":
    case "risk_score.immediate_alert":
    case "safeguarding.alert":
      return "critical";
    case "risk_score.red":
      return "red";
    case "risk_score.amber":
      return "amber";
    default:
      return "amber";
  }
}

interface SeverityCarrier {
  event_type: string;
  severity?: AlertSeverity | null;
}

// TASK-35: column-first classification for stored notifications.
// Falls back to event_type mapping when severity is absent (legacy rows).
export function severityForNotification(n: SeverityCarrier): AlertSeverity {
  return n.severity ?? severityForEventType(n.event_type);
}
